import Phaser from 'phaser';
import { MODELS } from '../objects/costume';
import Player, { preload as preloadPlayer } from '../objects/player';
import Background, {
  preload as preloadBackground,
} from '../objects/background';
import Ornament, { preload as preloadOrnament } from '../objects/ornament';
import Character, {
  preload as preloadCharacters,
  NAMES,
} from '../objects/character';
import { preload as preloadAudio } from '../objects/audio';
import { fadeOutSound } from '../utils';
import { getAssetsUrl } from 'utilities';

import EVENTS from 'constants/EVENTS';
import { landbotHeight, groundHeight } from '../definitions';

/**
 * Act 3 - Party house.
 */
export default class Act3 extends Phaser.Scene {
  constructor() {
    super({ key: 'Act3', active: false });
  }

  init(data) {
    this.data.set('costume', data.costume);
  }

  preload() {
    this.load.setBaseURL(getAssetsUrl());

    preloadBackground.call(this, 'wood', 'wood_pattern.png');
    preloadBackground.call(this, 'ground', 'ground.png');

    preloadOrnament.call(this, 'window', 'window.png');
    preloadOrnament.call(this, 'window_open', 'window_open.png');
    preloadOrnament.call(this, 'spider_web_1', 'spider_web_1.png');
    preloadOrnament.call(this, 'spider_web_2', 'spider_web_2.png');
    preloadOrnament.call(this, 'pumpkin_1', 'pumpkin_1.png');
    preloadOrnament.call(this, 'pumpkin_2', 'pumpkin_2.png');
    preloadOrnament.call(this, 'spiders_two', 'spiders_two.png');
    preloadOrnament.call(this, 'spiders_two_long', 'spiders_two_long.png');
    preloadOrnament.call(this, 'pumpkin_walking', 'pumpkin_walking.png');
    preloadOrnament.call(this, 'bats', 'bats.png');
    preloadOrnament.call(this, 'cat', 'cat.png');
    preloadOrnament.call(this, 'coffin', 'coffin.png');
    preloadOrnament.call(this, 'candles', 'candles.png');
    preloadOrnament.call(this, 'phantoms', 'phantoms.png');
    preloadOrnament.call(this, 'phantoms_teeths', 'phantoms_teeths.png');

    preloadAudio.call(this, 'ambience', 'dancing_pumpkins.mp3');

    Array(6)
      .fill(null)
      .forEach((a, index) => {
        this.load.image(`candy${index + 1}`, `ornaments/candy${index + 1}.png`);
      });

    preloadPlayer.call(this, this.data.get('costume') || MODELS.MUMMY);

    preloadCharacters.call(this);

    // preloadAudio.call(this, 'knock', 'knock.mp3');
  }

  create() {
    this.cameras.main.setBackgroundColor('#5E4993');
    this.cameras.main.fadeIn(1500);
    this.time.delayedCall(1500, () => {
      __landbot.events.emit(EVENTS.SET_VISIBLE, true);
    });

    // GAME OBJECTS

    this.wall = new Background(
      this,
      0,
      this.game.config.height,
      this.game.config.width,
      this.game.config.height,
      'wood'
    );

    this.ground = new Background(
      this,
      0,
      this.game.config.height - landbotHeight,
      this.game.config.width,
      20,
      'ground'
    );

    const spider_web_1 = new Ornament(this, 0, 0, 'spider_web_1');
    spider_web_1.setOrigin(0, 0);
    spider_web_1.setScale(0.8);

    const pumpkin_1 = new Ornament(
      this,
      300,
      this.game.config.height - landbotHeight - groundHeight,
      'pumpkin_2'
    );
    pumpkin_1.setOrigin(0.5, 1);
    pumpkin_1.setScale(0.8);
    pumpkin_1.setFlipX(true);

    const window_1 = new Ornament(
      this,
      800,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'window'
    );
    window_1.setOrigin(0.5, 1);
    window_1.setScale(0.8);

    const spiders_two_1 = new Ornament(this, 800 + 80, 0, 'spiders_two');
    spiders_two_1.setOrigin(0, 0);
    spiders_two_1.setScale(0.8);

    this.firstCharacter = new Character(
      this,
      800 + 500,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.MEXICAN_WOMAN
    );

    const pumpkin_walking = new Ornament(
      this,
      800 + 500 + 200,
      this.game.config.height - landbotHeight - groundHeight,
      'pumpkin_walking'
    );
    pumpkin_walking.setOrigin(0.5, 1);
    pumpkin_walking.setScale(0.8);

    const bats = new Ornament(
      this,
      800 + 500 + 400,
      this.game.config.height - landbotHeight - groundHeight - 340,
      'bats'
    );
    bats.setOrigin(0.5, 1);
    bats.setScale(0.8);

    const window_2 = new Ornament(
      this,
      800 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'window'
    );
    window_2.setOrigin(0.5, 1);
    window_2.setScale(0.8);

    const pumpkin_2 = new Ornament(
      this,
      800 + 1200 + 450,
      this.game.config.height - landbotHeight - groundHeight,
      'pumpkin_1'
    );
    pumpkin_2.setOrigin(0.5, 1);
    pumpkin_2.setScale(0.8);

    this.secondCharacter = new Character(
      this,
      800 + 1200 + 550,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.COWBOY
    );

    const window_3 = new Ornament(
      this,
      800 + 1200 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'window'
    );
    window_3.setOrigin(0.5, 1);
    window_3.setScale(0.8);

    const cat = new Ornament(
      this,
      800 + 1200 + 1220,
      this.game.config.height - landbotHeight - groundHeight,
      'cat'
    );
    cat.setOrigin(0.5, 1);
    cat.setScale(0.8);
    
    this.thirdCharacter = new Character(
      this,
      800 + 1200 + 1200 + 450,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.OLD_WOMAN
    );

    const spiders_two_2 = new Ornament(
      this,
      800 + 1200 + 1200 + 400,
      0,
      'spiders_two'
    );
    spiders_two_2.setOrigin(0, 0);
    spiders_two_2.setScale(0.8);

    const spider_web_2 = new Ornament(
      this,
      800 + 1200 + 1200 + 850,
      this.game.config.height - landbotHeight - groundHeight,
      'spider_web_1'
    );
    spider_web_2.setFlipY(true);
    spider_web_2.setOrigin(0, 1);
    spider_web_2.setScale(0.8);

    const coffin = new Ornament(
      this,
      800 + 1200 + 1200 + 800,
      this.game.config.height - landbotHeight - groundHeight,
      'coffin'
    );
    coffin.setOrigin(0.5, 1);
    coffin.setScale(0.8);

    const candles = new Ornament(
      this,
      800 + 1200 + 1200 + 1000,
      this.game.config.height - landbotHeight - groundHeight,
      'candles'
    );
    candles.setOrigin(0.5, 1);
    candles.setScale(0.6);

    const window_4 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'window_open'
    );
    window_4.setOrigin(0.5, 1);
    window_4.setScale(0.8);

    this.fourthCharacter = new Character(
      this,
      800 + 1200 + 1200 + 1200 + 600,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.SCREAM
    );

    const bats_2 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 900,
      this.game.config.height - landbotHeight - groundHeight - 340,
      'bats'
    );
    bats_2.setOrigin(0.5, 1);
    bats_2.setScale(0.6);

    const window_5 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'window'
    );
    window_5.setOrigin(0.5, 1);
    window_5.setScale(0.8);

    const phantoms_1 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 360,
      this.game.config.height - landbotHeight - groundHeight - 120,
      'phantoms'
    );
    phantoms_1.setOrigin(0.5, 1);
    phantoms_1.setScale(0.6);

    this.fifthCharacter = new Character(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 850,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.NUN
    );
    
    // const spiders_two_3 = new Ornament(
    //   this,
    //   800 + 1200 + 1200 + 1200 + 1200 + 1200,
    //   0,
    //   'spiders_two_long'
    // );
    // spiders_two_3.setOrigin(0.5, 0);
    // spiders_two_3.setScale(0.8);

    const spider_web_3 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 160,
      'spider_web_2'
    );
    spider_web_3.setOrigin(0.5, 0);
    spider_web_3.setScale(0.7);

    const window_6 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 1200,
      this.game.config.height - landbotHeight - groundHeight - 150,
      'window'
    );
    window_6.setOrigin(0.5, 1);
    window_6.setScale(0.8);

    const phantoms_2 = new Ornament(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 1200 + 360,
      this.game.config.height - landbotHeight - groundHeight - 220,
      'phantoms_teeths'
    );
    phantoms_2.setOrigin(0.5, 1);
    phantoms_2.setScale(0.6);
    
    this.monster = new Character(
      this,
      800 + 1200 + 1200 + 1200 + 1200 + 1200 + 800,
      this.game.config.height - landbotHeight - groundHeight - 5,
      NAMES.MONSTER
    );

    this.player = new Player(
      this,
      0,
      this.game.config.height - landbotHeight - groundHeight - 5
    );
    this.player.setOrigin(0.5, 1);
    this.player.setScale(0.8);
    this.player.stickCandies();

    this.audio = {
      // background: this.sound.add('music', {
      //   volume: 0.5,
      //   loop: true,
      // }),
      // close_wood: this.sound.add('close_wood', {
      //   volume: 0.8,
      // }),
      // knock: this.sound.add('knock'),
      // poof: this.sound.add('poof'),
      ambience: this.sound.add('ambience', {
        volume: 0.1,
        loop: true,
      }),
    };

    // PHYSICS

    this.physics.world.setBounds(
      0,
      0,
      1200 * 8,
      this.game.config.height
    );
    this.physics.world.setBoundsCollision(true);

    this.physics.add.existing(this.ground);
    this.ground.body.setSize(1200 * 20, 20);
    this.ground.body.setAllowGravity(false);
    this.ground.body.immovable = true;

    this.player.body.setCollideWorldBounds(true);

    this.physics.add.collider(this.player, this.ground);
    this.physics.add.collider(this.firstCharacter, this.ground);
    this.physics.add.collider(this.secondCharacter, this.ground);
    this.physics.add.collider(this.thirdCharacter, this.ground);
    this.physics.add.collider(this.fourthCharacter, this.ground);
    this.physics.add.collider(this.fifthCharacter, this.ground);
    this.physics.add.collider(this.monster, this.ground);

    // SCRIPT

    this.audio.ambience.play();

    this.cameras.main.setBounds(
      0,
      0,
      1200 * 8,
      this.game.config.height
    );
    this.cameras.main.startFollow(this.player);

    __landbot.events.on(EVENTS.PLAYER_MOVE, () => {
      this.player.move();
    });

    this.firstCharEncounter = this.physics.add.overlap(
      this.player,
      this.firstCharacter,
      firstCharEncounter.bind(this),
      null,
      this
    );

    this.secondCharEncounter = this.physics.add.overlap(
      this.player,
      this.secondCharacter,
      secondCharEncounter.bind(this),
      null,
      this
    );

    this.thirdCharEncounter = this.physics.add.overlap(
      this.player,
      this.thirdCharacter,
      thirdCharEncounter.bind(this),
      null,
      this
    );
    
    this.fourthCharEncounter = this.physics.add.overlap(
      this.player,
      this.fourthCharacter,
      fourthCharEncounter.bind(this),
      null,
      this
    );
    
    this.fifthCharEncounter = this.physics.add.overlap(
      this.player,
      this.fifthCharacter,
      fifthCharEncounter.bind(this),
      null,
      this
    );

    this.monsterEncounter = this.physics.add.overlap(
      this.player,
      this.monster,
      monsterEncounter.bind(this),
      null,
      this
    );

    __landbot.events.on(EVENTS.ACT_3_ENDING, () => {
      this.time.delayedCall(2000, () => {
        __landbot.events.emit(EVENTS.SET_VISIBLE, false);
        this.cameras.main.fadeOut(1500);
        fadeOutSound.call(this, this.audio.ambience, 1500);
      });
      this.time.delayedCall(2000 + 1500, () => {
        __landbot.events.emit(EVENTS.ACT_4);
      });
    });

    // this.cursor = this.input.keyboard.createCursorKeys();
  }

  update() {
    // if (this.cursor.right.isDown) {
    //   this.player.body.setVelocityX(500);
    //   this.player.flipX = false;
    // } else if (this.cursor.left.isDown) {
    //   this.player.body.setVelocityX(-500);
    //   this.player.flipX = true;
    // } else {
    //   this.player.body.setVelocity(0);
    // }

    this.wall.tilePositionX = this.cameras.main.scrollX * 1;
  }
}

function firstCharEncounter() {
  this.physics.world.removeCollider(this.firstCharEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.MEXICAN_WOMAN}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'MEXICAN_WOMAN',
  });

  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.firstCharacter.revealFace(window.__variables?.char1);
  });
}

function secondCharEncounter() {
  this.physics.world.removeCollider(this.secondCharEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.COWBOY}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'COWBOY',
  });

  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.secondCharacter.revealFace(window.__variables?.char2);
  });
}

function thirdCharEncounter() {
  this.physics.world.removeCollider(this.thirdCharEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.OLD_WOMAN}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'OLD_WOMAN',
  });

  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.thirdCharacter.revealFace(window.__variables?.char3);
  });
}

function fourthCharEncounter() {
  this.physics.world.removeCollider(this.fourthCharEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.SCREAM}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'SCREAM',
  });

  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.fourthCharacter.revealFace(window.__variables?.char4);
  });
}

function fifthCharEncounter() {
  this.physics.world.removeCollider(this.fifthCharEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.NUN}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: 'NUN',
  });
  
  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.fifthCharacter.revealFace(window.__variables?.char5);
  });
}

function monsterEncounter() {
  this.physics.world.removeCollider(this.monsterEncounter);
  this.player.stop();
  __landbot.events.emit(EVENTS.SET_SPEAKER, getAssetsUrl(`characters/${NAMES.MONSTER}_head.png`));
  __landbot.events.emit(EVENTS.SEND_MESSAGE, {
    message: '_MONSTER',
  });
  
  __landbot.events.once(EVENTS.REVEAL_FACE, () => {
    this.monster.revealMonsterFace();
    __landbot.events.emit(EVENTS.SET_SPEAKER, {
      avatar: getAssetsUrl('characters/bat.png'),
      onlyAvatar: true,
    });
  });
}
